import imagesLoaded from 'imagesloaded';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

let lastScrollTop = 0;

gsap.registerPlugin(ScrollTrigger);

export function scrollTriggers() {

}

export function bodyUtils() {
  imagesLoaded.makeJQueryPlugin($);

  $('body').imagesLoaded(function() {
    $('body').addClass('is-loaded').trigger('loaded');
  });

  $('.is-style-link:not(:has(*)), .is-style-link:has(.screen-reader-text)').each(function() {
    const svgElement = '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
        '<path d="M10.4238 0C10.8809 0 11.2676 0.386719 11.2676 0.84375V9.28125C11.2676 9.77344 10.8809 10.125 10.4238 10.125C9.93164 10.125 9.58008 9.77344 9.58008 9.28125V2.88281L1.45898 11.0039C1.10742 11.3555 0.580078 11.3555 0.263672 11.0039C-0.0878906 10.6875 -0.0878906 10.1602 0.263672 9.84375L8.38477 1.72266H1.98633C1.49414 1.72266 1.14258 1.33594 1.14258 0.878906C1.14258 0.386719 1.49414 0.0351562 1.98633 0.0351562H10.4238V0Z" fill="currentColor"/>\n' +
        '</svg>\n';

    $(this).append(svgElement);
  });

  $('.wp-block-button.is-style-link .wp-block-button__link').each(function() {
    const svgElement = '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
        '<path d="M10.4238 0C10.8809 0 11.2676 0.386719 11.2676 0.84375V9.28125C11.2676 9.77344 10.8809 10.125 10.4238 10.125C9.93164 10.125 9.58008 9.77344 9.58008 9.28125V2.88281L1.45898 11.0039C1.10742 11.3555 0.580078 11.3555 0.263672 11.0039C-0.0878906 10.6875 -0.0878906 10.1602 0.263672 9.84375L8.38477 1.72266H1.98633C1.49414 1.72266 1.14258 1.33594 1.14258 0.878906C1.14258 0.386719 1.49414 0.0351562 1.98633 0.0351562H10.4238V0Z" fill="currentColor"/>\n' +
        '</svg>\n';

    $(this).append(svgElement);
  });

  $('.site-header .wp-block-navigation__submenu-container').each(function() {
    $(this).prepend('<button aria-label="Close submenu" class="submenu-close-btn">Back</button>');
  });

  $('.wp-block-navigation-submenu__toggle').on('click', function() {
    const $parent = $(this).parent();
    const $submenu = $(this).siblings('.wp-block-navigation-submenu');

    // Flag to track if transitionend has already been handled
    let transitionHandled = false;

    $submenu.one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function() {
      if (!transitionHandled) {
        $parent.toggleClass('submenu-open');
        transitionHandled = true;
      }
    });
  });

  $('.submenu-close-btn').on('click', function() {
    $(this).parent().siblings('.wp-block-navigation-submenu__toggle').trigger('click');
  });

  $(document).on('click', '.wp-block-navigation-item:not(.has-child)', () => {
    $('.wp-block-navigation__responsive-container-close').trigger('click');
  });

  $(document).ready(function() {
    // Step 1: Find the first .is-style-page-section element inside the .entry-content div
    var firstSection = $('.entry-content > *').first();

    if (firstSection.length) {
      // Step 2: Prepend an empty div with the class of mobile-title-spacer inside the first section
      firstSection.prepend($('<div>', { class: 'mobile-title-spacer' }));
    }
  });
}

export function windowScrollUtils() {
  const $body = $('body');
  const $window = $(window);
  const $siteHeader = $('.site-header');

  let st = $window.scrollTop();
  const scrollThreshold = 20;

  const $scrollMarkers = $('.scroll-marker');
  const siteHeaderHeight = $siteHeader.outerHeight();
  const lastScrollMarker = $scrollMarkers.last();

  if ($scrollMarkers.length) {
    // Calculate the critical scroll position
    const criticalScrollPosition = lastScrollMarker.offset().top - siteHeaderHeight;

    if (st < lastScrollTop && lastScrollTop > criticalScrollPosition) {
      $body.removeClass('header-hidden');
      $body.addClass('header-sticky');
    }

    if (st > lastScrollTop && lastScrollTop > criticalScrollPosition) {
      $body.addClass('header-hidden');
      $body.removeClass('header-sticky');
    }

    if (st < criticalScrollPosition) {
      $body.addClass('header-top');
      $body.removeClass('header-sticky');
      $body.removeClass('header-hidden');
    }

    if (st > criticalScrollPosition) {
      $body.removeClass('header-top');
    }
  } else {
    if (st < ( lastScrollTop - scrollThreshold )) {
      $body.removeClass('header-hidden');
      $body.addClass('header-sticky');
    }

    if (st > lastScrollTop) {
      $body.addClass('header-hidden');
      $body.removeClass('header-sticky');
    }

    if (st < 50) {
      $body.addClass('header-top');
      $body.removeClass('header-sticky');
      $body.removeClass('header-hidden');
    }

    if (st > 50) {
      $body.removeClass('header-top');
    }
  }

  lastScrollTop = st;
}

export function formUtils() {
  // Function to check the value of the input
  function checkInput($input) {
    const $label = $input.closest('.gfield').find('.gform-field-label');

    if ($input.val() !== '' || $input.is(':focus')) {
      $label.addClass('active');
    } else {
      $label.removeClass('active');
    }
  }

  // Apply the check on page load, focus, and blur events
  $('.gform_body').find('input[type="text"], input[type="email"], textarea').each(function() {
    checkInput($(this));
  }).on('focus blur', function() {
    checkInput($(this));
  });
}

export function postLoadUtils() {
  // Options for the observer (which thresholds to notify on)
  var observerOptions = {
    root: null, // observing relative to the viewport
    rootMargin: '0px',
    threshold: 1.0, // trigger when 100% of the target is visible
  };

  // Callback function for the observer
  var observerCallback = function(entries, observer) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        // URL of the next page
        var nextPageUrl = $(entry.target).attr('href');

        // Fetch the next page using jQuery AJAX
        $.ajax({
          url: nextPageUrl,
          type: 'GET',
          success: function(response) {
            // Parse the HTML response
            var html = $.parseHTML(response);
            var newPosts = $(html).find('.wp-block-post'); // adjust this selector based on your HTML structure

            // Hide new posts initially
            newPosts.hide();

            // Append new posts to the existing container
            $('.wp-block-post-template').append(newPosts);

            // Fade in new posts
            newPosts.fadeIn(1000); // 1000 milliseconds for fade-in duration

            // Update the pagination link or hide if no more pages
            var newNextPageLink = $(html).find('.wp-block-query-pagination-next');
            if (newNextPageLink.length) {
              $(entry.target).attr('href', newNextPageLink.attr('href'));
            } else {
              // No more pages to load, unobserve and hide pagination
              observer.unobserve(entry.target);
              $(entry.target).parent().hide(); // Hides the pagination container
            }
          },
          error: function(xhr, status, error) {
            console.error('Failed to fetch the next page: ', error);
          },
        });
      }
    });
  };

  // Create an observer instance linked to the callback function
  var observer = new IntersectionObserver(observerCallback, observerOptions);

  // Start observing the pagination link
  var target = $('.wp-block-query-pagination > a').get(0);
  if (target) observer.observe(target);
}
